export const ONE_SECOND_MS = 1000
export const THIRTY_SECONDS_MS = 30000
export const ONE_MINUTE_MS = 60000
export const FIVE_MINUTES_MS = 300000
export const FIFTEEN_MINUTES_MS = 900000
export const THIRTY_MINUTES_MS = 1800000
export const FORTY_FIVE_MINUTES_MS = 2700000
export const ONE_HOUR_MS = 3600000
